import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const StarredEmptyStateLoader: LoadableType<{}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-StarredEmptyState" */ '../components/StarredEmptyState.tsx'
			)
		).StarredEmptyState,
});
